import React from 'react'
import PropTypes from 'prop-types'
import ContentWrapper from '../shared/content-wrapper'
import CtaButton from '../buttons/cta-button'
import Icon from '../icons/icon'
import HeadingGamma from '../headings/heading-gamma'
import HeadingDelta from '../headings/heading-delta'
import SignForm from '../shared/sign-form'

const ResendToken = props => (
  <ContentWrapper>
    <SignForm>
      <div className='prominent-icon'>
        <Icon name='warning' />
      </div>
      <HeadingGamma>Verify your email</HeadingGamma>
      {props.isLinkSent ? (
        <HeadingDelta thin>
          A new link has been sent to your email address.
        </HeadingDelta>
      ) : (
        <div>
          <HeadingDelta thin>
            Sorry, we couldn't confirm your email. Verification links have an
            expire time so they are valid only for 24h after delivery.
          </HeadingDelta>

          <div className='top-space bottom-space'>
            <CtaButton
              text='Send me a new link!'
              iconName='delivery'
              onClick={props.onResendVerificationClick}
              isLoading={props.isResending}
              disabled={props.isResending || props.isLinkSent}
            />
          </div>
        </div>
      )}
    </SignForm>
  </ContentWrapper>
)

ResendToken.propTypes = {
  // injected by decorator
  onResendVerificationClick: PropTypes.func,
  isResending: PropTypes.bool,
  isLinkSent: PropTypes.bool
}

export default ResendToken



// WEBPACK FOOTER //
// ./src/ui/email-verification/ResendToken.js